import { render, staticRenderFns } from "./Dashboard_WebCastle.vue?vue&type=template&id=4a396ba8&"
import script from "./Dashboard_WebCastle.vue?vue&type=script&lang=js&"
export * from "./Dashboard_WebCastle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports